import { Request } from 'Types';

export type RequestData = {
  id: number;
  reference: string;
  enterprise: string;
  createdAt: Date;
  date: string;
  origin: string;
  destination: string;
  agency: string;
  mpl: string;
  price: string;
  shipper: string;
  dangerous: boolean;
  handlingUnitNb: number;
  status: string;
  label: string;
};

export const formatRequests = (requests: Request[]): RequestData[] => {

  return requests?.map(
    ({
      id,
      reference,
      company,
      account,
      createdAt,
      date,
      originCity,
      originCountry,
      originZipcode,
      destinationCity,
      destinationCountry,
      destinationZipcode,
      floorMeters,
      handlingUnitNb,
      lastValidQuotation,
      user,
      status,
      dangerous,
    }) => ({
      id,
      reference,
      enterprise: `${company.name} (${account.codeTiers.startsWith('$') ? 'Prospect' : account.codeTiers
        })`,
      createdAt,
      date,
      origin: `${originCountry} ${originCity} ${originZipcode.slice(0, 2)}`,
      destination: `${destinationCountry} ${destinationCity} ${destinationZipcode.slice(
        0,
        2,
      )}`,
      mpl: `${floorMeters}`,
      handlingUnitNb: handlingUnitNb,
      price: lastValidQuotation ? `${lastValidQuotation.totalAmount} €` : 'X',
      agency: account.agency.code,
      shipper: user.role === 'CLIENT' ? '/' : user.fullName.split(' ').map((part, index) => {
        if (index === 0) return part.charAt(0);
        if (index === 1) return part.substring(0, 1);
      }).join(''),
      dangerous: dangerous,
      status: status.label,
      label: status.value,
    }),
  );
};
